import { render, staticRenderFns } from "./modal_account_post.vue?vue&type=template&id=219362da&scoped=true"
import script from "./modal_account_post.vue?vue&type=script&lang=js"
export * from "./modal_account_post.vue?vue&type=script&lang=js"
import style0 from "./modal_account_post.vue?vue&type=style&index=0&id=219362da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219362da",
  null
  
)

export default component.exports